import React from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import { usePartner } from "../context/PartnerContext";

const PublicNavbar = () => {
  const location = useLocation();
  const { appName, partner, tagline } = usePartner();
  const isAuthPage =
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/register");
  return (
    <header className="public-navbar">
      <div className="public-navbar-inner">
        <div className="public-navbar-left">
          <Link to="/" className="public-logo-wrap">
            <span className="public-logo">{appName}</span>
            {partner ? (tagline && <span className="public-pill">{tagline}</span>) : <span className="public-pill">Multi-Strategy CopyTrading</span>}
          </Link>
        </div>
        <div className="public-navbar-right" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <ThemeToggle />
          <Link to="/brokers" className="public-link">
            Open account
          </Link>
          {!isAuthPage && (
            <>
              <Link to="/login" className="btn btn-ghost btn-xs">
                Sign in
              </Link>
              <Link to="/register" className="btn btn-primary btn-xs">
                Get started
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default PublicNavbar;
